import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AccountCamMicActions } from "@youm-front/account-cammic/data-access";
import { DeviceActions } from "@youm-front/device/data-access";
import { NoticeFacade } from "@youm-front/notice/data-access";
import { NoticeCreate1Cmd } from "@youm-front/notice/domain";
import { tap } from "rxjs/operators";

@Injectable()
export class AccountCamMicEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly noticeFacade: NoticeFacade
  ) {}

  accountCamMicError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          DeviceActions.loadDevicesFailure,
          AccountCamMicActions.streamFailure
        ),
        tap((_) =>
          this.noticeFacade.noticeCreate(
            new NoticeCreate1Cmd({
              kind: "error",
              data: `${$localize`Access to the webcam or audio device is currently unavailable. Please ensure that these devices are not already in use by another application or another page.`} (${
                _.error.name
              }, ${_.error.message})`
            })
          )
        )
      ),
    { dispatch: false }
  );
}
